import _ from 'lodash';
import React from 'react';
import HypertouchDeviceRow from './HypertouchDeviceRow.jsx';
import HypertouchDevicesEmptyState from './HypertouchDevicesEmptyState.jsx';

export default class HypertouchDevicesListView extends React.Component {
  render() {
    const { devices, totalDevicesCount, viewLoading, selectedDevice, onSelectDevice, listContainerStyle } = this.props;

    return (
      <div className="list-view details-section" style={{ top: 140, paddingBottom: 60, width: '90%', ...listContainerStyle }}>
        <div className="r-full-width-phone" style={{ width: '40%' }}>
          {!_.isEmpty(devices) ? (
            _.map(devices, device => (
              <HypertouchDeviceRow
                key={device.serial}
                device={device}
                isSelected={selectedDevice && selectedDevice.serial === device.serial}
                onClick={() => onSelectDevice(device)}
              />
            ))
          ) : (
            <HypertouchDevicesEmptyState viewLoading={viewLoading} totalDevicesCount={totalDevicesCount} />
          )}
        </div>
      </div>
    );
  }
}
